import { default as processClassNames } from 'classnames'
import css from '../../global-nav.scss'
import ToggleNav from '../../components/ToggleNav'

import { findPath, storePath } from 'lib/urls'

interface MinimalSiteNavSectionProps {
  classNames: any
  handleToggleNav: () => void
  trackClick: (eventCta: string) => void
}

const MinimalSiteNavSection = ({
  trackClick,
  classNames,
  handleToggleNav,
}: MinimalSiteNavSectionProps) => (
  <ul
    className={processClassNames(
      classNames,
      css.GlobalNav__MinimalSiteNavSection
    )}
  >
    <ToggleNav onClick={handleToggleNav} />
    <li className={processClassNames('hidden-xs', css.navLink)}>
      <a href={storePath} onClick={() => trackClick('Shop')}>
        Shop
      </a>
    </li>

    <li className={processClassNames('hidden-xs', css.navLink)}>
      <a href={findPath} onClick={() => trackClick('Find Registry')}>
        Find Registry
      </a>
    </li>
  </ul>
)

export default MinimalSiteNavSection
